import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';

import './index.scss';

export default function InfoSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Índice por Cultura"
      className="agro-ci-area-info-sheet"
    >
      <div className="agro-ci-area-info-body">
        <section className="agro-ci-area-info-section">
          <h3 className="agro-ci-area-info-title">Sobre</h3>
          <p>
            O
            {' '}
            <b>Índice de Cultura</b>
            {' '}
            indica o quão favoráveis estão as condições para o desenvolvimento de uma cultura
            agrícola num determinado período, combinando temperatura e disponibilidade de água em
            cada fase do ciclo. As cores do mapa vão do azul (menos favorável) ao vermelho (mais
            favorável).
          </p>
          <p>
            Toque num
            {' '}
            <b>pin</b>
            {' '}
            para abrir a análise detalhada daquela localidade, ou em qualquer ponto do mapa para ver
            o valor do índice mais próximo.
          </p>
        </section>

        <section className="agro-ci-area-info-section">
          <h3 className="agro-ci-area-info-title">Como comparar dois mapas</h3>
          <ol className="agro-ci-area-info-steps">
            <li>Toque em “Adicionar mapa” para incluir um segundo mapa (limite de 2).</li>
            <li>
              No painel de controle, use as abas “Mapa 1” / “Mapa 2” para definir cultura, data de
              previsão e período de cada mapa — eles são independentes.
            </li>
            <li>Toque em “Consultar os 2 mapas” para carregar os dois de uma vez.</li>
            <li>
              Alterne entre ver os mapas empilhados (um sob o outro) ou um de cada vez pelo botão de
              layout.
            </li>
          </ol>
        </section>
      </div>
    </BottomSheet>
  );
}
